import { ErrorState } from '../shared/ErrorState';

type OverviewSectionErrorProps = {
  title: string;
  onRetry: () => void;
};

export const OverviewSectionError = ({ title, onRetry }: OverviewSectionErrorProps) => (
  <section>
    <div className="flex items-center justify-between mb-4">
      <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
    </div>
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <ErrorState
        message={`Failed to load ${title.toLowerCase()} data.`}
        onRetry={onRetry}
      />
    </div>
  </section>
);
